// filepath: apps/web/src/features/directory/organization-tree/OrganizationTreeRoute.tsx
//
// FR-UI-DIR-1 AC-3 — route shell for /organization.

import { OrganizationTreePage } from "./OrganizationTreePage";

export function OrganizationTreeRoute(): React.ReactElement {
  return <OrganizationTreePage />;
}
